import React, { useEffect, useState } from "react";
import "react-toastify/dist/ReactToastify.css";
import { Link, useParams, useLocation, useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import axios from "axios";

const StudentDetailsView = () => {
  const { id } = useParams();
  const navigate = new useNavigate();
  const [student, setStudent] = useState({});

  useEffect(() => {
    // Fetch student data to pre-fill the form
    const fetchStudentData = async () => {
      try {
        const token = JSON.parse(localStorage.getItem("token"));
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/api/student/fetch/${id}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (response.status === 200) {
          setStudent(response.data); // Set the form data with the fetched student details
        } else {
          toast.error("Failed to fetch student data.");
        }
      } catch (error) {
        toast.error("An error occurred while fetching student data.");
      }
    };

    fetchStudentData();
  }, [id]);

  const handleDelete = async (studentId) => {
    try {
      const token = JSON.parse(localStorage.getItem("token"));
      const response = await axios.delete(
        `${process.env.REACT_APP_API_URL}/api/student/${student.student_id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.status === 200) {
        // window.scrollTo({ top: 0, behavior: "smooth" });
        setTimeout(() => {
          navigate(`/erp/students/details/class/${student.student_class}`);
        }, 2000);
        toast.success("Student deleted successfully!");
      }
    } catch (error) {
      toast.error("Error deleting student");
    }
  };

  return (
    <>
      <div className="container mt-5 bg-white rounded p-5 mb-5">
        <div className="row">
          <div className="col-12 d-flex justify-content-between align-items-center">
            <Link
              to={`/erp/students/details/class/${student.student_class}`}
              className="btn btn-secondary mb-3 pe-4"
            >
              &#8592; Back
            </Link>

            <h3 className="text-center text-success">Student Details</h3>
          </div>
          <div className="text-center d-flex justify-content-end">
            <h5>Student ID - {id}</h5>
          </div>
        </div>

        <div className="table-responsive mt-3">
          <table className="table table-bordered table-striped table-hover align-middle">
            <thead className="table-primary">
              <tr>
                <th style={{ width: "45%" }}>Field</th>
                <th>Details</th>
              </tr>
            </thead>
            <tbody>
              {Object.entries({
                "Student Name": student.student_name,
                "Class Roll No.": student.class_roll_number
                  ? student.class_roll_number
                  : " ",
                Class: student.student_class,
                Gender: student.gender === "MALE" ? "MALE" : "FEMALE",
                "Date of Birth": student.dob,
                "Aadhar Number": student.aadhar_number,
                "Admission Number": student.admission_number,
                "Date of Admission": student.date_of_admission,
                Session: student.session,
                Category: student.category,
                "Blood Group": student.blood_group,
                "Mother Tongue": student.mother_tongue,
                Nationality: student.nationality,
                "Father's Name": student.father_name,
                "Father's Contact Number": student.contact_number_father,
                "Father's Occupation": student.father_occupation,
                "Mother's Name": student.mother_name,
                "Mother's Contact Number": student.contact_number_mother,
                "Mother's Occupation": student.mother_occupation,
                Email: student.email ? student.email : " ",
                Address: student.address,
                "Police Station": student.police_station,
                "Post Office": student.post_office,
                District: student.district,
                State: student.state || "Jharkhand",
                Pincode: student.pincode,
                Expelled: student.expelled ? "Yes" : "No",
                "Siblings in School": student.siblings_in_school ? "Yes" : "No",
                "Siblings' Name and Class": student.siblings_in_school
                  ? student.siblings_name_class
                  : "-",
                "Admission Fees Paid": student.admission_fees_paid
                  ? "Yes"
                  : "No",
                Transportation: student.transportation ? "Yes" : "No",
                Declaration: student.declaration ? "Yes" : "No",
              }).map(([key, value]) => (
                <tr key={key}>
                  <td className="fw-bold">{key}</td>
                  <td>{value || "N/A"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="gap-2 mt-4">
          <Link to={`/erp/students/update/${student.student_id}`}>
            <button
              type="submit"
              className="btn btn-primary me-3"
              style={{ width: "14%" }}
            >
              Edit Details
            </button>
          </Link>

          <button
            type="button"
            className="btn btn-danger"
            data-bs-toggle="modal"
            data-bs-target="#deleteModal"
          >
            Delete Student
          </button>

          <div
            className="modal fade"
            id="deleteModal"
            tabIndex="-1"
            aria-labelledby="exampleModalLabel"
            aria-hidden="true"
          >
            <div className="modal-dialog">
              <div className="modal-content">
                <div className="modal-header">
                  <h1 className="modal-title fs-5" id="exampleModalLabel">
                    Confirm Deletion
                  </h1>
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  ></button>
                </div>
                <div className="modal-body">
                  Do you want to delete the student detail ?
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-secondary"
                    data-bs-dismiss="modal"
                  >
                    Close
                  </button>
                  <button
                    type="button"
                    onClick={handleDelete}
                    className="btn btn-danger"
                    data-bs-dismiss="modal"
                  >
                    Delete Student
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <ToastContainer />
      </div>
    </>
  );
};

export default StudentDetailsView;
